<template>
  <div class="address-location">
    <!-- 搜索 -->
    <div class="search-box">
      <input type="search" placeholder="输入关键字搜索" v-model="searchKey" />
      <div class="close" v-show="searchKey" @click="searchKey = ''"></div>
    </div>
    <div class="p-r">
      <div class="main-box">
        <!-- 地图 -->
        <div class="map-box">
          <div class="map" id="J_map"></div>
          <div class="location-icon" v-if="map"></div>
          <div class="location-button" v-if="map" @click="goLocCenter"></div>
        </div>
        <div class="tip-list-box">
          <!-- 定位失败提示 -->
          <p v-if="!aMapObj.gps" class="location-fail">定位失败，以下为推荐结果</p>
          <!-- 地址列表 -->
          <div class="list-box">
            <ul v-if="placeSearchResult.length">
              <li class="item-panel" v-for="(item, index) in placeSearchResult" :key="index" @click="onResLi(item)">
                <i :class="index == 0 ? 'selected' : 'unselected'"></i>
                <div>
                  <span class="name" :class="{ 'name-selected': index == 0 }">{{ item.name }}</span>
                  <p class="address">{{ item.address }}</p>
                </div>
              </li>
            </ul>
            <v-list-loading v-else class="no-info" :loadingText="loadingFlag ? '正在加载' : '未找到结果'" />
          </div>
        </div>
      </div>
      <!-- 搜索列表 -->
      <div class="search-list" v-if="searchKey">
        <ul v-if="keySearchResult.length">
          <li class="item-panel" v-for="(item, index) in keySearchResult" :key="index" @click="onResLi(item)">
            <div>
              <span class="name">{{ item.name }}</span>
              <p class="address">{{ item.address }}</p>
            </div>
          </li>
        </ul>
        <div v-else class="no-result">
          <v-empty type="nosearch" description="暂无搜索结果"></v-empty>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import module from './module'
import { debounce } from 'utils/common'
import { page } from 'mixins'
import app from 'utils/app'
import env from 'utils/clientEnv'
export default {
  mixins: [page('map', module)],
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      map: null,
      searchKey: '', //搜索值
      noSearchShow: false
    }
  },
  watch: {
    searchKey(val) {
      debounce(this._keySearch, 300)()
    },
    isShow: {
      immediate: true,
      async handler(newVal) {
        if (newVal) {
          this.initMap()
        } else {
          this.clear()
        }
      }
    }
  },
  methods: {
    clear() {
      this.searchKey = ''
      this.clearMapResult()
      this.map = null
      // if (this.map && this.aMapObj.location) {
      //   this.setMapCenter({ map: this.map })
      //   return
      // }
    },
    goLocCenter() {
      if (this.aMapObj.location) {
        this.setMapCenter({ map: this.map })
        return
      } else {
        this.getLocation().then(res => {
          if (res) {
            this.setMapCenter({ map: this.map })
          }
        })
      }
    },
    getLocation() {
      return new Promise(resolve => {
        const parentDomain = document?.referrer?.split('/')[2] || '';//父页面域名
        const currentDomain = window.location?.hostname;//子页面域名
        if (env.isIOSVivoApp && parentDomain != currentDomain) {
          //解决ios官网APP内的定位问题
          this.getWebLocation().then(res=>{resolve(res)})
          return 
        }
        app.getLocation(
          res => {
            // 未开启定位权限触发
            if (!res.longitude || !res.latitude) {
              resolve(null)
              return
            }
            this.setAMapObj({
              center: [res.longitude, res.latitude],
              isGps: true
            })
            resolve([res.longitude, res.latitude])
          },
          () => {
            this.getWebLocation().then(res=>{resolve(res)})
          }
        )
      })
    },
    getWebLocation() {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      }
      return new Promise(resolve => {
        navigator.geolocation.getCurrentPosition(
          res => {
            let crd = res.coords
            this.setAMapObj({
              center: [crd.longitude, crd.latitude],
              isGps: true
            })
            resolve([crd.longitude, crd.latitude])
          },
          () => {
            resolve(null)
           },
          options
        )
      })
    },
    async initMap() {
      await this.getLocation()
      this.initMapCavas(map => {
        this.map = map
      })
    },
    _keySearch() {
      this.keySearch(this.searchKey)
    },
    onResLi(item) {
      const pos = [item.location.lng, item.location.lat]
      this.getGeocoderAddress({
        lnglat: pos,
        callback: async (status, result) => {
          if (status === 'complete' && result.info === 'OK') {
            const { province, city, district, adcode, township } = result.regeocode?.addressComponent
            const formattedArea = Array.isArray(district) ? district[0] || township : district || township
            let detailAddress = ''
            if ((province + formattedArea).indexOf(item.address) >= 0) {
              const formattedAddress = result.regeocode?.formattedAddress || ''
              const splitArray = formattedAddress.split(formattedArea)
              if (splitArray && splitArray.length > 1) {
                splitArray.shift()
              }
              const address = splitArray.join('') || item.address
              detailAddress = address + ' ' + item.name
            } else {
              detailAddress = item.address + ' ' + item.name
            }

            this.$emit('change', {
              province,
              city: city || province,
              area: formattedArea,
              detailAddress: detailAddress,
              citycode: adcode
            })
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped src="./index.scss"></style>
